import { render } from "./ContactsView.vue?vue&type=template&id=0f798108&scoped=true"
import script from "./ContactsView.vue?vue&type=script&lang=js"
export * from "./ContactsView.vue?vue&type=script&lang=js"

import "./ContactsView.vue?vue&type=style&index=0&id=0f798108&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Дентакорплюс\\dentakor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f798108"]])

export default __exports__